import React, { PropTypes } from 'react'
import { Link } from 'react-router'
import cx from 'classnames'

import './ServiceItem.scss'
import Avatar from 'components/Avatar'
import InformationModal from 'components/InformationModal'
import { formatDate } from 'utils/dates'
import { userModifyService } from 'utils/paths'
import { URGENT_ALIADA_ID } from '@src/globals'

const fullName = ({firstName, lastName}) => {
  return lastName ? `${firstName} ${lastName}` : firstName
}

const ServiceItem = ({service, userId, modified}) => {
  const {
    id: serviceId,
    datetime,
    cost,
    estimatedHours
  } = service

  const aliada = service.aliada || {}
  const explanationModal = !service.aliada
    ? (
      <InformationModal>
        <h2>Aliada por confirmar</h2>
        <p>Aun no hemos asignado una Aliada para tu servicio. Pero no te preocupes, aproximadamente 5 días antes de tu cita podrás saber cual Aliada te visitará.</p>
      </InformationModal>
    )
    : null

  const componentClassName = cx(
    'ServiceItem',
    {
      'ServiceItem--modified': modified,
      'ServiceItem--noAliada': !service.aliada
    }
  )

  if (!service.aliada) {
    aliada.profilePicture = {}
    aliada.firstName = 'Por asignar'
    aliada.lastName = ''
  }

  const isUrgentService = aliada.id == URGENT_ALIADA_ID

  return (
    <div className={componentClassName}>
      <Avatar
        image={aliada.profilePicture.original}
        size={60}
        />

      <div className='ServiceItem-serviceInfo'>
        <p className='ServiceItem-aliadaName'>{fullName(aliada)}{explanationModal}</p>
        <p className='ServiceItem-date'>
          <span className='ServiceItem-dateMonth'>{formatDate('D [de] MMMM', datetime)}</span>
          <span className='ServiceItem-dateWeekHour'>{formatDate('dddd h:mm a', datetime)}</span>
        </p>
        <p className='ServiceItem-serviceHours'>{parseInt(estimatedHours)} horas</p>
        <p className='ServiceItem-servicePrice'>${cost}</p>
      </div>

      <div className='ServiceItem-actions'>
        {!isUrgentService &&
        <Link to={userModifyService(userId, serviceId)} className='ServiceItem-modify'>
          <span className='icon-pencil' />
          Modificar
        </Link>}
      </div>
    </div>
  )
}

ServiceItem.displayName = 'ServiceItem'
ServiceItem.propTypes = {
  service: PropTypes.shape({
    id: PropTypes.number.isRequired,
    datetime: PropTypes.string.isRequired,
    cost: PropTypes.number.isRequired,
    estimatedHours: PropTypes.string.isRequired,
    serviceTypeId: PropTypes.string.isRequired,
    aliada: PropTypes.shape({
      firstName: PropTypes.string.isRequired,
      lastName: PropTypes.string,
      profilePicture: PropTypes.shape({
        original: PropTypes.string.isRequired
      }).isRequired
    })
  }).isRequired,
  userId: PropTypes.string.isRequired,
  modified: PropTypes.bool
}
ServiceItem.defaultProps = {
  modified: false
}

export default ServiceItem



// WEBPACK FOOTER //
// ./src/screens/App/screens/UserProfile/screens/UserServices/screens/NextServices/components/RecurrenceCard/components/ServiceItem/ServiceItem.js